import React from 'react';

export default function PackageOptionPickerModal({ templates, onSelect, onStartFresh, onCancel }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--surface, #fff)', borderRadius: 14, padding: '32px 36px',
        minWidth: 420, maxWidth: 480, maxHeight: '70vh', overflowY: 'auto',
        boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
        display: 'flex', flexDirection: 'column', gap: 16,
      }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 17 }}>Load Package Option</div>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>
            Pick a preset to pre-fill its inclusions and exclusions as an unchecked checklist — tick whichever apply to this quotation.
          </div>
        </div>
        {templates.length === 0 ? (
          <div style={{ fontSize: 13, color: 'var(--text-muted)', fontStyle: 'italic' }}>
            No package options set up yet. Add them under Settings → Package Options.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {templates.map(t => (
              <button
                key={t.id}
                onClick={() => onSelect(t)}
                style={{
                  padding: '12px 16px', borderRadius: 8, border: '2px solid var(--border, #e5e7eb)',
                  background: 'transparent', textAlign: 'left', cursor: 'pointer',
                }}
              >
                <div style={{ fontWeight: 600, fontSize: 14 }}>{t.name}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>
                  {t.destination ? `${t.destination} · ` : ''}{(t.inclusions || []).length} inclusions, {(t.exclusions || []).length} exclusions
                </div>
              </button>
            ))}
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', borderTop: '1px solid var(--border)', paddingTop: 16 }}>
          <button onClick={onCancel} className="btn btn-secondary">Cancel</button>
          <button onClick={onStartFresh} className="btn btn-secondary">Start Fresh</button>
        </div>
      </div>
    </div>
  );
}
